// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__1TDAa","table":"Table_table__9kXon","th":"Table_th__7x0O7","td":"Table_td__RWUQ8","tr":"Table_tr__mxs-N","empty":"Table_empty__Yjk2L"};